/**
 * Firebase Client SDK initialization
 * Used by the web frontend to interact with Firebase services
 */

import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics'

// Production Firebase configuration
// Uses environment variables in development, falls back to production values in build
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyD9dhuawGDmpgi6TiI1ziuR0qSCZ4-snuo",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "na404-0731.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "na404-0731",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "na404-0731.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "758593689336",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:758593689336:web:ecdf548886efa365588d0d",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-0000000000",
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app, 'asia-southeast1')
export const remoteConfig = getRemoteConfig(app)

// Initialize Analytics (only in production and if supported)
// Analytics is not available in emulator mode
let analytics: Analytics | null = null
if (import.meta.env.VITE_USE_EMULATOR !== 'true' && import.meta.env.PROD) {
  isSupported().then(yes => {
    if (yes) {
      analytics = getAnalytics(app)
      console.log('📊 Firebase Analytics initialized')
    }
  }).catch(err => {
    console.warn('Analytics not supported:', err)
  })
}
export { analytics }

// Set default values for Remote Config
remoteConfig.defaultConfig = {
  enable_secret_santa: false,
}

// Set minimum fetch interval (1 hour in production, 0 in development for testing)
remoteConfig.settings.minimumFetchIntervalMillis =
  import.meta.env.VITE_USE_EMULATOR === 'true' ? 0 : 3600000

// Fetch and activate Remote Config values
fetchAndActivate(remoteConfig).catch(err => {
  console.error('Error fetching Remote Config:', err)
})

// Connect to emulators in development
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectFunctionsEmulator(functions, 'localhost', 5001)

  console.log('🔧 Connected to Firebase emulators')
}

export default app
